import React, { useState, useRef,useEffect }  from 'react'
import PngImg from '../../images/sample-car.png'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function GenAIImg() {
    const [loadingMsg, setLoadingMsg]= useState(false)
    const [translationResult, setTranslationResult]= useState('')
    const [userInput, setUserInput] = useState({'theme':'rose garden'})
    const [bg, setBg] = useState('https://dummyjson.com/image/250x180/e5e7eb/000000?text=Change+Your+Background')
    const [loadSample, setLoadSample]= useState(false)
    async function Run() {
      const { data: res } = await axios.post(`${APIURL}/llm/generate-smaple-img`,userInput)
      setBg(`data:image/png;base64,${res['img']}`)
      const ctx = document.getElementById('canvas1').getContext('2d')
      const img1 =new Image()
      img1.onload = () => {
        ctx.drawImage(img1, 0, 0, 250, 180)
      }
      img1.src=`data:image/png;base64,${res['img']}`
      setTimeout(function(){ 
      const img2 = new Image()
      img2.onload = () => {
        ctx.drawImage(img2, -25, 47)
      }
      img2.src = process.env.NODE_ENV === 'production'?`${process.env.REACT_APP_URL}${PngImg.slice(1)}`:PngImg 
      }, 200)
      setLoadSample(true)
    }
    if(!loadSample){
      Run()  
    }
    const onChange2Input = ({ currentTarget: x }) => { setUserInput({ ...userInput, [x.name]: x.value })}    
    const onClick2Generate=async()=>{
        setLoadingMsg(true)
        try {
            const { data: res } = await axios.post(`${APIURL}/llm/generate-img`,userInput)
            setBg(`data:image/png;base64,${res['img']}`)
            const ctx = document.getElementById('canvas1').getContext('2d')
            const img1 =new Image()
            img1.onload = () => {
              ctx.drawImage(img1, 0, 0, 250, 180)
            }
            img1.src=`data:image/png;base64,${res['img']}`
            setTimeout(function(){ 
              const img2 = new Image()
              img2.onload = () => {
                ctx.drawImage(img2, -25, 47)
              }
              img2.src = process.env.NODE_ENV === 'production'?`${process.env.REACT_APP_URL}${PngImg.slice(1)}`:PngImg 
            }, 200)
            setLoadingMsg(false)
        } catch (err) {
            console.log(err)
        }
    }
    const onClick2Download = async() =>{
      try {        
        var link = document.createElement('a')
        link.href = document.getElementById('canvas1').toDataURL('image/png', 1.0)
        link.download = 'car_image.png'
        document.body.appendChild(link)
        link.click()
      } catch (err) {
          console.log(err)
      }
    }
      return (
      <>
        Where do you want to drive? Set a location.<br/>
        <div className='mb-[2px] flex'>
        <input className='pl-[2px] border border-gray-800 w-full md:w-80 mr-[2px]' type='text' defaultValue='rose garden' onChange={onChange2Input}/>
        <button className='bg-gray-800 hover:bg-gray-700 h-auto pl-[8px] pr-[8px] text-white text-[12px]' onClick={onClick2Generate}>Generate Image</button>
        </div>
        {loadingMsg?<p className='text-xs'>Asking AI to create your image...</p>
        :''}
        <canvas id='canvas1' width='250' height='180' style={{border:'1px solid black'}}></canvas>
        <button className='bg-gray-800 hover:bg-gray-700 h-[26px] pl-[8px] pr-[8px] text-white text-[12px]' onClick={onClick2Download}>Download</button>
       
        <div className='text-left'>
        {translationResult}
        </div>
       </>
      )
}